import Tenancy from "./Tenancy";

export default Tenancy;